import { inject, Injectable } from '@angular/core';
import { SquareDeviceEndpoints } from 'app/core/enums/endpoints/gateway.enum';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';
import { SquareDevicePayload } from '../../types';

@Injectable({
    providedIn: 'root',
})
export class SquareDeviceService {
    private _endpoint = SquareDeviceEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // ------------------------------------------------------------------
    // @ CRUD methods
    // ------------------------------------------------------------------

    getAll(params: {
        gatewayId: number;
        productionId: number;
    }): Observable<any> {
        return this._apiService.getWithQueryParams(this._endpoint.getAll, {
            gateway_id: params.gatewayId,
            production_id: params.productionId,
        });
    }

    getAllUnassigned(params: {
        gatewayId: number;
        productionId: number;
    }): Observable<any> {
        return this._apiService.get(
            `${this._endpoint.getAllUnassigned}?gateway_id=${params.gatewayId}&production_id=${params.productionId}`
        );
    }

    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    create(data: SquareDevicePayload): Observable<any> {
        return this._apiService.post(this._endpoint.create, data);
    }

    update(data: SquareDevicePayload, id: number): Observable<any> {
        return this._apiService.update(this._endpoint.update, data, id);
    }

    delete(id: number): Observable<any> {
        return this._apiService.delete(this._endpoint.delete, id);
    }
}
